import React from 'react';
import PropTypes from 'prop-types';
import { View, TouchableOpacity } from 'react-native';
import { query } from '@dbk-legacy/muster/react';
import { pure } from '@dbk/ui-react-utils';

import NavigationArrow from '../navigation-arrow';
import styles from './link.styles';

function Link(props) {
  const { style, children, to, testID, push, onPress, arrowVisible } = props;

  const handlePress =
    (onPress && onPress) || (() => to && push && push({ pathname: to }));

  return (
    <TouchableOpacity
      testID={testID}
      onPress={handlePress}
      style={[styles.root, style]}
    >
      <View style={styles.children}>{children}</View>
      {arrowVisible && <NavigationArrow />}
    </TouchableOpacity>
  );
}

Link.propTypes = {
  style: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
    PropTypes.number,
  ]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  to: PropTypes.string,
  testID: PropTypes.string,
  push: PropTypes.func,
  onPress: PropTypes.func,
  arrowVisible: PropTypes.bool,
};

Link.defaultProps = {
  arrowVisible: true,
};

const PureLink = pure(Link);

export { PureLink as Link };

export default query({
  push: { $call: 'ui.history.push' },
})(Link);
